import { LoadingOutlined } from '@ant-design/icons';
import { calculaValoresFrete } from '@sotran/lib-shipper';
import { MultiSelect } from '@tmov/design-system';
import {
  Col,
  DatePicker,
  Form,
  notification,
  Popconfirm,
  Radio,
  Row,
  Select,
} from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useDebouncedCallback } from 'use-debounce/lib';

import TarifaClienteTmov from '../../../../../../components/TarifaClienteTmov';
import { SubTitle } from '../../../../../../components/Typography';
import Tmov from '../../../../../../domains/Tmov';
import { getFaixaTarifaTmov } from '../../../../../../helpers/calculaValoresLote';
import { pegarDataUtc } from '../../../../../../helpers/data';
import {
  configTonelada,
  filterOption,
  novaMoneyConfig,
  showErrors,
} from '../../../../../../helpers/form';
import {
  formatarCnpjCpfIMask,
  formatarMoedaIMask,
  removeMoedaMask,
  removeThousandSeparatorMask,
  toFixedNumber,
} from '../../../../../../helpers/formatador';
import { getValueTagGA } from '../../../../../../helpers/geradores';
import { gTagSaida } from '../../../../../../helpers/googleAnalytics';
import {
  validateCadencia,
  validateCadenciaMovimentado,
  validateVolumeMovimentado,
} from '../../../../../../helpers/validators';
import { useAuth } from '../../../../../../security/authContext';
import apiNetCore from '../../../../../../services/apiNetCore';
import apiShipper from '../../../../../../services/apiShipper';
import DirecionamentoEnum from '../../../../Enum/DirecionamentoEnum';
import PedagioEnum from '../../../../Enum/PedagioEnum';
import StatusLoteEnum from '../../../../Enum/StatusLoteEnum';
import TipoDirecionamentoEnum from '../../../../Enum/TipoDirecionamentoEnum';
import { Switch as SwitchAntd } from '../../../styles';
import AgendamentoInfo from './AgendamentoInfo';
import ParametroValores from './parametroValores';
import {
  AgendamentoLoadingContainer,
  AvisoFinalizar,
  Button,
  CancelarAgendamentoButton,
  CancelarButton,
  Label,
  Modal,
  Row as RowAntd,
} from './styles';

export default function ModalCriarLote({
  demanda,
  title,
  showModal,
  handleCloseModal,
  onSaveLote,
  setFreteInserido,
  freteInserido,
  dadosPagador,
  formDemanda,
  endereco,
  lote,
  icms,
  valorPedagio,
  tarifaTmovClienteLista,
  eventId,
  empresasParceiras,
  todosLotesInclusos,
  tipoLote,
}) {
  const direcionamentoOption = DirecionamentoEnum.getTiposLabel();
  const tipoDirecionamentoOption = TipoDirecionamentoEnum.getTiposLabel();
  const statusLoteOption = StatusLoteEnum.getTiposLabel();

  const { user } = useAuth();
  const [
    apiFrotistaOrGrupoFrotistas,
    setApiFrotistaOrGrupoFrotistas,
  ] = useState([]);
  const [direcionamentoSelected, setDirecionamentoSelected] = useState(
    direcionamentoOption[0]
  );
  const [tipoDirecionamentoSelected, setTipoDirecionamentoSelected] = useState(
    demanda.livreConcorrencia
      ? tipoDirecionamentoOption[1].value
      : tipoDirecionamentoOption[0].value
  );
  const [loadingDirecionamento, setLoadingDirecionamento] = useState(false);
  const [switchFretePf, setSwitchFretePf] = useState(true);
  const [form] = Form.useForm();
  const [tarifaTmov, setTarifaTmov] = useState(0);
  const [isTarifaPercentual, setIsTarifaPercentual] = useState(true);
  const [dadosEndereco, setDadosEndereco] = useState({});
  const [descricaoProduto, setDescricaoProduto] = useState('');
  const [pedagioIncluso, setPedagioIncluso] = useState(false);
  const [disableModalSalvar, setDisableModalSalvar] = useState(true);
  const [editingLote, setEditingLote] = useState(false);
  const [isFrotistaValid, setIsFrotistaValid] = useState(false);
  const [isCadenciaMovimentadaValid, setIsCadenciaMovimentadaValid] = useState(
    true
  );
  const [isVolumeMovimentadoValid, setIsVolumeMovimentadoValid] = useState(
    true
  );
  const [isPeriodoValid, setIsPeriodoValid] = useState(true);
  const [isTransportadora, setIsTransportadora] = useState(false);
  const [loadingAgendamento, setLoadingAgendamento] = useState(false);
  const [dataAgendamento, setDataAgendamento] = useState(false);
  const [dadosAgendamento, setDadosAgendamento] = useState();
  const [
    transportadorasSelecionadas,
    setTransportadorasSelecionadas,
  ] = useState([]);
  const [idsTransportadoras, setIdsTransportadoras] = useState([]);
  const [statusSelected, setStatusSelected] = useState();
  const [qtdMotorista, setQtdMotorista] = useState(0);
  const [previousLoteData, setPreviousLoteData] = useState({
    volume: 0,
    cadencia: 0,
    frete: 0,
  });
  const [disableStatus, setDisableStatus] = useState(false);

  const [empresasOptions, setEmpresasOptions] = useState([]);
  const empresasSelecionadas = useMemo(
    () => empresasOptions.filter(option => option.checked),
    [empresasOptions]
  );

  const validaDadosEndereco = novoEndereco =>
    novoEndereco.idEstadoOrigem === dadosEndereco.idEstadoOrigem &&
    novoEndereco.idEstadoDestino === dadosEndereco.idEstadoDestino &&
    novoEndereco.idCidadeOrigem === dadosEndereco.idCidadeOrigem &&
    novoEndereco.idCidadeDestino === dadosEndereco.idCidadeDestino;

  useEffect(() => {
    async function getDadosForm() {
      const dadosForm = formDemanda.getFieldsValue(true);
      const produto = dadosForm.descricaoProduto;
      setPedagioIncluso(dadosForm.pedagio === PedagioEnum.PEDAGIO_INCLUSO);

      setDescricaoProduto(produto);
      if (validaDadosEndereco(endereco)) return;

      setDadosEndereco(endereco);
    }

    getDadosForm();
  }, [form, endereco]);

  useEffect(() => {
    async function getInitModal() {
      form.resetFields();
      setEmpresasOptions([]);
      setDirecionamentoSelected(direcionamentoOption[0]);

      if (tipoLote === 'TRANSPORTADORA') {
        form.setFieldsValue({
          tipoDirecionamento: TipoDirecionamentoEnum.TRANSPORTADORA,
        });
        setTipoDirecionamentoSelected(TipoDirecionamentoEnum.getTipo(2));
        setIsTransportadora(true);
      } else {
        setTipoDirecionamentoSelected(TipoDirecionamentoEnum.getTipo(1));
        setIsTransportadora(false);
      }

      setSwitchFretePf(true);
      setTarifaTmov(0);
      setDisableModalSalvar(true);
      setPedagioIncluso(false);
      setEmpresasOptions(
        empresasParceiras.map(empresa => ({
          id: empresa.id,
          label: empresa.razaoSocial,
          checked: empresa.id === Tmov.idEmpresa,
          unselectable: empresa.id === Tmov.idEmpresa,
        }))
      );

      if (
        demanda.livreConcorrencia &&
        !editingLote &&
        empresasParceiras.find(empresa => empresa.id === Tmov.idEmpresa)
      ) {
        form.setFieldsValue({
          transportadora: [
            {
              id: Tmov.idEmpresa,
              label: Tmov.razaoSocial,
              checked: true,
              unselectable: true,
            },
          ],
        });
      }

      setIdsTransportadoras(
        empresasParceiras.find(empresa => empresa.id === Tmov.idEmpresa)
          ? [Tmov.idEmpresa]
          : []
      );
      setTransportadorasSelecionadas([]);
      setQtdMotorista(lote?.qtdMotoristasTransitoEmFila || 0);
    }

    getInitModal();
  }, [showModal, form]);

  const fields = ['dataInicio', 'volume', 'cadencia'];

  const validateForm = async () => {
    if (
      direcionamentoSelected.value !== DirecionamentoEnum.PUBLICO &&
      tipoDirecionamentoSelected.value === TipoDirecionamentoEnum.MARKETPLACE
    ) {
      fields.push(`direcionadoPara${direcionamentoSelected.value}`);
    }

    if (direcionamentoSelected.value !== DirecionamentoEnum.FROTISTA) {
      setIsFrotistaValid(true);
    }

    if (
      tipoDirecionamentoSelected.value === TipoDirecionamentoEnum.TRANSPORTADORA
    ) {
      fields.push('transportadora');
      fields.push('freteEmpresaShipper');
    } else {
      fields.push('freteMotoristaPj');
      fields.push('freteEmpresaPj');
    }

    if (demanda.livreConcorrencia) {
      form.setFieldsValue({
        cadencia: demanda.cadenciaDiariaTotal,
        volume: demanda.volumeTotal,
      });
    }

    const fieldsValue = form.getFieldsValue(fields);

    const disable =
      Object.values(fieldsValue).filter(value => !value).length !== 0;

    let isCadenciaMaior = true;

    const isFieldsValid =
      isCadenciaMovimentadaValid &&
      isVolumeMovimentadoValid &&
      isPeriodoValid &&
      isFrotistaValid;

    if (!disable) {
      const { cadencia, volume } = form.getFieldsValue(true);

      const novaCadencia = removeThousandSeparatorMask(cadencia);
      const novoVolume = removeThousandSeparatorMask(volume);

      if (novaCadencia <= novoVolume) {
        isCadenciaMaior = false;
      }
    }

    if (
      demanda?.livreConcorrencia &&
      idsTransportadoras.length === 0 &&
      tipoDirecionamentoSelected.value ===
        TipoDirecionamentoEnum.TRANSPORTADORA &&
      !editingLote
    ) {
      setDisableModalSalvar(true);
      return true;
    }

    if (!isCadenciaMaior && isFieldsValid) {
      setDisableModalSalvar(false);
      return false;
    }

    setDisableModalSalvar(true);
    return true;
  };

  const validateFormDebounced = useDebouncedCallback(validateForm, 300);

  const handleDirecionadoPara = (
    callbackFrotista,
    callbackGrupoFrotista,
    direcionamento
  ) => {
    if (direcionamento === DirecionamentoEnum.FROTISTA) {
      return callbackFrotista;
    }
    if (direcionamento === DirecionamentoEnum.GRUPO_FROTISTA) {
      return callbackGrupoFrotista;
    }
    return null;
  };

  const copiaFretePj = switchChecked => {
    if (switchChecked) {
      const { freteMotoristaPj, freteEmpresaPj } = form.getFieldsValue(true);

      form.setFieldsValue({
        freteMotoristaPf: freteMotoristaPj,
        freteEmpresaPf: freteEmpresaPj,
      });
    }
  };

  const calculaFretes = (value, tipo, segmentacao) => {
    let tipoCalculo = 'freteMotorista';
    let salveField = 'freteEmpresa';

    const valor = removeMoedaMask(value || 0);

    if (tipo !== freteInserido) setFreteInserido(tipo);

    const novoValorPedagio =
      form.getFieldValue('pedagio') === PedagioEnum.PEDAGIO_INCLUSO
        ? 0
        : valorPedagio;

    if (tipo !== 'motorista') {
      tipoCalculo = 'freteEmpresa';
      salveField = 'freteMotorista';
    }

    const tarifaTmovFaixa =
      segmentacao === 'PJ'
        ? getFaixaTarifaTmov(
            segmentacao,
            tarifaTmovClienteLista,
            valor,
            isTarifaPercentual
          )
        : tarifaTmov;

    const resultado = calculaValoresFrete(
      valor,
      tipoCalculo,
      tarifaTmovFaixa,
      isTarifaPercentual,
      0,
      novoValorPedagio
    );

    const resultadoFormatado = formatarMoedaIMask(toFixedNumber(resultado, 2));

    if (segmentacao === 'PJ') {
      form.setFieldsValue({
        [`${salveField}Pj`]: resultadoFormatado,
      });
    } else if (segmentacao === 'PF') {
      form.setFieldsValue({
        [`${salveField}Pf`]: resultadoFormatado,
      });
    } else {
      form.setFieldsValue({
        [`${salveField}Pj`]: resultadoFormatado,
        [`${salveField}Pf`]: resultadoFormatado,
      });
    }

    setTarifaTmov(tarifaTmovFaixa);
    copiaFretePj(switchFretePf);
  };

  const recalculaFretes = () => {
    const {
      freteMotoristaPj,
      freteEmpresaPj,
      freteMotoristaPf,
      freteEmpresaPf,
    } = form.getFieldsValue(true);

    const valorFretePJ =
      freteInserido === 'motorista' ? freteMotoristaPj : freteEmpresaPj;
    const valorFretePF =
      freteInserido === 'motorista' ? freteMotoristaPf : freteEmpresaPf;

    calculaFretes(valorFretePJ, freteInserido, 'PJ');
    if (valorFretePF) {
      calculaFretes(valorFretePF, freteInserido, 'PF');
    }
  };

  const calculaFretesDebounced = useDebouncedCallback(calculaFretes, 300);

  const onChangeSwitchPedagio = checked => {
    form.setFieldsValue({
      pedagio: checked ? PedagioEnum.PEDAGIO_INCLUSO : PedagioEnum.COM_PEDAGIO,
    });

    recalculaFretes();
    setPedagioIncluso(checked);
  };

  const handleDirecionamento = async index => {
    setDirecionamentoSelected(direcionamentoOption[index]);
    setApiFrotistaOrGrupoFrotistas([]);
  };

  const handleTipoDirecionamento = async value => {
    setTipoDirecionamentoSelected(TipoDirecionamentoEnum.getTipo(value));

    if (value === TipoDirecionamentoEnum.MARKETPLACE) {
      form.setFieldsValue({
        razaoSocialTransportadora: null,
        idTransportadora: null,
        transportadora: null,
        direcionamento: TipoDirecionamentoEnum.MARKETPLACE,
      });
      setDirecionamentoSelected(direcionamentoOption[0]);
      setIsTransportadora(false);
    } else {
      setIsTransportadora(true);
    }
  };

  const handleSearchGrupoFrotistas = async value => {
    if (!value || value.length < 3) return;

    setLoadingDirecionamento(true);

    try {
      const { data } = await apiShipper.get(
        `/grupo-frotista/${user.cliente_tmov_id}`,
        {
          params: {
            nome: value,
          },
        }
      );

      setApiFrotistaOrGrupoFrotistas(data);
    } catch (err) {
      notification.error({
        message: 'Ops, não foi possível recuperar o grupo frotistas',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    } finally {
      setLoadingDirecionamento(false);
    }
  };

  const handleSearchFrotistas = async value => {
    if (!value || value.length < 3) return;

    setLoadingDirecionamento(true);
    try {
      const { data } = await apiShipper.get('/frotista/ativo', {
        params: {
          filtro: value,
        },
      });

      setApiFrotistaOrGrupoFrotistas(data);
    } catch (err) {
      notification.error({
        message: 'Ops, não foi possível recuperar os frotistas',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    } finally {
      setLoadingDirecionamento(false);
    }
  };

  const onSearchFrotistas = useDebouncedCallback(async value => {
    handleSearchFrotistas(value);
  }, 1000);

  const onSearchGrupoFrotistas = useDebouncedCallback(async value => {
    handleSearchGrupoFrotistas(value);
  }, 1000);

  const selectOptionFrotista = frotista => (
    <Select.Option
      key={frotista.id}
      value={`${frotista.razao_social}`}
      cnpj={frotista.cnpj}
    >
      {`${frotista.razao_social}`}
      <br />
      {`${frotista.nome_fantasia}`}
      <br />
      {`${formatarCnpjCpfIMask(frotista.cnpj)}`}
    </Select.Option>
  );

  const selectOptionGrupoFrotista = grupoFrotista => (
    <Select.Option
      key={grupoFrotista.idGrupoFrotista}
      value={grupoFrotista.nome}
    >
      {`${grupoFrotista.nome}`}
    </Select.Option>
  );

  const handleSelectFrotista = async (value, { cnpj }) => {
    try {
      setIsFrotistaValid(false);
      const { data } = await apiNetCore.get(
        `/Proprietario/Consultar?cnpjcpfProprietario=${cnpj}`,
        {
          filtro: {
            value,
          },
        }
      );

      if (data.Objeto?.IdProprietario) {
        setIsFrotistaValid(true);
        form.setFieldsValue({
          [`direcionadoPara${DirecionamentoEnum.FROTISTA}`]: `${value} - ${formatarCnpjCpfIMask(
            cnpj
          )}`,
          idProprietario: data.Objeto?.IdProprietario,
        });
      } else {
        form.setFieldsValue({
          [`direcionadoPara${DirecionamentoEnum.FROTISTA}`]: null,
          idProprietario: null,
        });
        throw new Error();
      }
    } catch ({ response }) {
      notification.warn({
        message: 'Ops, não foi possível selecionar o frotista',
        description:
          'Este frotista não está na plataforma de frotistas do TMOV.',
      });
    }
  };

  const handleSelectGrupoFrotista = async (
    _value,
    { key: idGrupoFrotista }
  ) => {
    form.setFieldsValue({
      idGrupoFrotista,
    });
  };

  const closeModal = () => {
    form.resetFields();
    setStatusSelected(0);
    handleCloseModal();
  };

  const fieldsValueTransportadoraPadrao = {
    tipoDirecionamento: TipoDirecionamentoEnum.TRANSPORTADORA,
    idGrupoFrotista: null,
    idProprietario: null,
    direcionamento: null,
    freteTotalPj: 0,
    freteTotalPf: 0,
    freteMotoristaPj: 0,
    freteMotoristaPf: 0,
    pedagio: PedagioEnum.SEM_PEDAGIO,
  };

  const isValorMudando = (valorEditado, valorAntigo) => {
    const valorAtual = form.getFieldValue(valorEditado);
    const parsedValorAtual = removeThousandSeparatorMask(valorAtual);
    if (valorAntigo !== parsedValorAtual) {
      return removeThousandSeparatorMask(valorAtual);
    }
    return null;
  };

  const isFreteMudando = (freteEditado, valorAntigo) => {
    const freteAtual = form.getFieldValue(freteEditado);
    const parsedFreteAtual = removeMoedaMask(freteAtual);
    if (valorAntigo !== parsedFreteAtual) {
      return parsedFreteAtual;
    }
    return null;
  };

  const isStatusMudando = (statusEditado, statusAntigo) => {
    const statusAtual = form.getFieldValue(statusEditado);
    if (statusAntigo !== statusAtual) {
      return statusAtual;
    }
    return null;
  };

  const handleAgendamentoLote = async () => {
    const {
      enderecoOrigem,
      enderecoDestino,
      razaoSocialClientePagador,
    } = demanda;
    const origem = `${enderecoOrigem[0].cidade} (${enderecoOrigem[0].estado})`.toUpperCase();
    const destino = `${enderecoDestino[0].cidade} (${enderecoDestino[0].estado})`.toUpperCase();
    const cliente_razao_social = razaoSocialClientePagador.toUpperCase();

    const volume = demanda.livreConcorrencia
      ? null
      : isValorMudando('volume', previousLoteData.volume);

    const cadencia = demanda.livreConcorrencia
      ? null
      : isValorMudando('cadencia', previousLoteData.cadencia);

    let frete_motorista_pf = null;
    let frete_motorista_pj = null;

    let frete_empresa_pf = null;
    let frete_empresa_pj = null;

    let frete_empresa_shipper = null;
    let status_lote = null;

    status_lote = isStatusMudando('status', lote.idStatus);

    if (lote.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE) {
      const allFormValues = form.getFieldsValue(true);
      frete_motorista_pf = isFreteMudando(
        'freteMotoristaPf',
        lote.freteMotoristaPf
      );
      frete_motorista_pj = isFreteMudando(
        'freteMotoristaPj',
        lote.freteMotoristaPj
      );

      if (frete_motorista_pf) {
        frete_empresa_pf = removeMoedaMask(allFormValues.freteEmpresaPf);
      }

      if (frete_motorista_pj) {
        frete_empresa_pj = removeMoedaMask(allFormValues.freteEmpresaPj);
      }
    }

    if (lote.tipoDirecionamento === TipoDirecionamentoEnum.TRANSPORTADORA) {
      frete_empresa_shipper = isFreteMudando(
        'freteEmpresaShipper',
        previousLoteData.frete
      );
    }

    if (
      volume ||
      cadencia ||
      frete_empresa_shipper ||
      frete_motorista_pf ||
      frete_motorista_pj ||
      status_lote
    ) {
      const payload = {
        id_lote: lote?.idLote,
        data_alteracao: dataAgendamento,
        filiais_email: lote.filiaisEmail,
        origem,
        destino,
        volume,
        cadencia,
        frete_empresa_shipper,
        frete_motorista_pf,
        frete_motorista_pj,
        frete_empresa_pf,
        frete_empresa_pj,
        cliente_razao_social,
        status_lote,
        tipo_pagamento: lote.tipoPagamento,
      };

      try {
        await apiShipper.post('/alteracao-lote', payload);
        notification.success({
          message: 'O agendamento foi realizado com sucesso!',
          description:
            'Agendamento de alterações de lote realizado com sucesso!',
        });
        setDataAgendamento(null);
      } catch {
        notification.error({
          message: 'Ops, não foi possível agendar o alterações ao lote',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
      }
    }
  };

  const handleSalvarLote = async () => {
    const allFormValues = form.getFieldsValue(true);

    const freteEmpresaPJ = removeMoedaMask(allFormValues.freteEmpresaPj || 0);
    const freteEmpresaPF = removeMoedaMask(allFormValues.freteEmpresaPf || 0);
    const freteMotoristaPJ = removeMoedaMask(
      allFormValues.freteMotoristaPj || 0
    );
    const freteMotoristaPF = removeMoedaMask(
      allFormValues.freteMotoristaPf || 0
    );

    const freteEmpresaShipper = removeMoedaMask(
      allFormValues.freteEmpresaShipper || 0
    );

    try {
      const data = {
        direcionamento: DirecionamentoEnum.PUBLICO,
        ...(allFormValues.direcionamento === DirecionamentoEnum.FROTISTA && {
          idProprietario: allFormValues.idProprietario,
          nomeFantasiaProprietario: allFormValues.direcionadoPara2.replace(
            /[^a-zA-Z ]/g,
            ''
          ),
          cnpjCpfProprietario: formatarCnpjCpfIMask(
            allFormValues.direcionadoPara2.replace(/\D+/g, '')
          ),
          direcionamento: DirecionamentoEnum.FROTISTA,
          idGrupoFrotista: null,
        }),
        ...(allFormValues.direcionamento ===
          DirecionamentoEnum.GRUPO_FROTISTA && {
          idGrupoFrotista: allFormValues.idGrupoFrotista,
          nomeGrupoFrotista: allFormValues.direcionadoPara3,
          direcionamento: DirecionamentoEnum.GRUPO_FROTISTA,
          idProprietario: null,
        }),

        tipoDirecionamento: TipoDirecionamentoEnum.MARKETPLACE,

        dataInicio: pegarDataUtc(allFormValues.dataInicio),
        dataFim: allFormValues.dataFim
          ? pegarDataUtc(allFormValues.dataFim)
          : null,
        volume: dataAgendamento
          ? previousLoteData.volume
          : removeThousandSeparatorMask(allFormValues.volume),
        cadencia: dataAgendamento
          ? previousLoteData.cadencia
          : removeThousandSeparatorMask(allFormValues.cadencia),
        volumeAux: removeThousandSeparatorMask(allFormValues.volume),
        cadenciaAux: removeThousandSeparatorMask(allFormValues.cadencia),

        idStatus: allFormValues.status
          ? allFormValues.status
          : StatusLoteEnum.CARREGANDO,
        pedagio: pedagioIncluso
          ? PedagioEnum.PEDAGIO_INCLUSO
          : PedagioEnum.COM_PEDAGIO,

        freteTotalPj: freteEmpresaPJ || freteEmpresaPF,
        freteTotalPf: freteEmpresaPF || freteEmpresaPJ,
        freteMotoristaPj: freteMotoristaPJ || freteMotoristaPF,
        freteMotoristaPf: freteMotoristaPF || freteMotoristaPJ,

        ...(allFormValues.tipoDirecionamento ===
          TipoDirecionamentoEnum.TRANSPORTADORA && {
          idTransportadora:
            allFormValues.idTransportadora || lote?.idTransportadora,
          razaoSocialTransportadora:
            allFormValues.razaoSocialTransportadora ||
            lote?.razaoSocialTransportadora,

          ...fieldsValueTransportadoraPadrao,

          freteEmpresaShipper,
        }),
        baseFreteShipper:
          freteInserido === 'motorista' ? freteInserido : 'total',
      };

      if (dataAgendamento) {
        handleAgendamentoLote();
      } else {
        onSaveLote(data, lote?.idLote);
      }
    } catch (error) {
      const errors = error?.response?.data?.errors
        ? Object.values(error?.response?.data?.errors)
        : null;
      showErrors(errors);
    } finally {
      form.resetFields();
      setDataAgendamento(null);
      closeModal();
    }
  };

  const handleSalvarMultiplosLotes = async () => {
    const allFormValues = form.getFieldsValue(true);

    const freteEmpresaShipper = removeMoedaMask(
      allFormValues.freteEmpresaShipper || 0
    );

    idsTransportadoras.forEach(id => {
      const transportadora = empresasParceiras.find(
        empresa => empresa.id === id
      );
      transportadorasSelecionadas.push(transportadora);
      setTransportadorasSelecionadas(transportadorasSelecionadas);
    });

    try {
      if (
        transportadorasSelecionadas &&
        transportadorasSelecionadas.length > 0
      ) {
        transportadorasSelecionadas.forEach(transportadora => {
          form.setFieldsValue({
            razaoSocialTransportadora: transportadora.razaoSocial,
            idTransportadora: transportadora.id,
          });

          const data = {
            dataInicio: pegarDataUtc(allFormValues.dataInicio),
            dataFim: allFormValues.dataFim
              ? pegarDataUtc(allFormValues.dataFim)
              : null,
            volume: removeThousandSeparatorMask(allFormValues.volume),
            cadencia: removeThousandSeparatorMask(allFormValues.cadencia),
            volumeAux: removeThousandSeparatorMask(allFormValues.volume),
            cadenciaAux: removeThousandSeparatorMask(allFormValues.cadencia),

            idStatus: allFormValues.status
              ? allFormValues.status
              : StatusLoteEnum.CARREGANDO,

            idTransportadora: transportadora.id || lote?.idTransportadora,
            razaoSocialTransportadora:
              transportadora.razaoSocial || lote?.razaoSocialTransportadora,

            ...fieldsValueTransportadoraPadrao,

            freteEmpresaShipper,

            baseFreteShipper:
              freteInserido === 'motorista' ? freteInserido : 'total',
          };

          onSaveLote(data, lote?.idLote);
        });
      }
    } catch (error) {
      const errors = error?.response?.data?.errors
        ? Object.values(error?.response?.data?.errors)
        : null;
      showErrors(errors);
    } finally {
      form.resetFields();
      closeModal();
    }
  };

  const handleGerenciarLote = async () => {
    const allFormValues = form.getFieldsValue(true);
    if (
      allFormValues.tipoDirecionamento ===
        TipoDirecionamentoEnum.TRANSPORTADORA &&
      demanda.livreConcorrencia &&
      !editingLote
    ) {
      handleSalvarMultiplosLotes();
    } else {
      handleSalvarLote();
    }
  };

  const handleTarifaClienteTmov = async () => {
    if (!tarifaTmovClienteLista) return;

    const isPercentualTmov = tarifaTmovClienteLista.tipoTarifa === 'PERCENTUAL';

    if (editingLote) {
      const valorFreteSalvo =
        freteInserido === 'motorista'
          ? form.getFieldValue('freteMotoristaPj')
          : form.getFieldValue('freteEmpresaPj');

      setTarifaTmov(
        getFaixaTarifaTmov(
          'PJ',
          tarifaTmovClienteLista,
          valorFreteSalvo,
          isPercentualTmov
        )
      );
    }

    setIsTarifaPercentual(isPercentualTmov);
  };

  const handleTarifaClienteTmovTransportadora = async () => {
    if (!tarifaTmovClienteLista) return;

    const isPercentualTmov = tarifaTmovClienteLista.tipoTarifa === 'PERCENTUAL';

    if (editingLote) {
      const valorFreteSalvo = form.getFieldValue('freteEmpresaShipper');

      setTarifaTmov(
        getFaixaTarifaTmov(
          'PJ',
          tarifaTmovClienteLista,
          valorFreteSalvo,
          isPercentualTmov
        )
      );
    }

    setIsTarifaPercentual(isPercentualTmov);
  };

  const handleCancelarAgendamento = async () => {
    try {
      await apiShipper.put('alteracao-lote', {
        status: 'CANCELADO',
        id_lote: lote.idLote,
      });
      setDadosAgendamento();
      notification.success({
        message: 'Agendamento cancelado com sucesso',
      });
    } catch {
      notification.error({
        message: 'Erro inesperado ao cancelar agendamento',
        description: 'Ocorreu um erro inesperado ao cancelar o agendamento',
      });
    }
  };

  useEffect(() => {
    validateFormDebounced();
  }, [
    isCadenciaMovimentadaValid,
    isVolumeMovimentadoValid,
    isPeriodoValid,
    isFrotistaValid,
  ]);

  useEffect(() => {
    validateFormDebounced();
  }, [form, formDemanda]);

  useEffect(() => {
    async function onInit() {
      handleTarifaClienteTmov();
    }

    onInit();
  }, [dadosEndereco, dadosPagador]);

  useEffect(() => {
    const loadAgendamento = async () => {
      if (!lote?.idLote) {
        return;
      }

      setLoadingAgendamento(true);

      try {
        const { data } = await apiShipper.get('alteracao-lote', {
          params: {
            id_lote: lote.idLote,
          },
        });

        if (data.IdLote) {
          setDadosAgendamento(data);
        }
      } catch {
        notification.error({
          message: 'Erro ao recuperar os dados de agendamento',
          description:
            'Não foi possível recuperar os dados de agendamento do lote',
        });
      } finally {
        setLoadingAgendamento(false);
      }
    };

    setDadosAgendamento();
    loadAgendamento();
  }, [lote]);

  const handleSubmitClient = () => {};

  const handleStatus = event => {
    validateFormDebounced();
    const { value, checked } = event.target;

    if (checked) setStatusSelected(value);
  };

  const onChangeSwitchFretePf = checked => {
    setSwitchFretePf(checked);
    copiaFretePj(checked);
    validateFormDebounced();
  };

  useEffect(() => {
    async function onEditingLote() {
      setDisableStatus(false);
      setEditingLote(false);

      if (lote === null || Object.values(lote).length === 0) {
        return;
      }

      if (lote) {
        onChangeSwitchFretePf(false);
        if (lote.freteMotoristaPj === lote.freteMotoristaPf) {
          if (
            lote.freteEmpresaPj === lote.freteEmpresaPf ||
            lote.freteTotalPj === lote.freteTotalPf
          ) {
            onChangeSwitchFretePf(true);
          }
        }

        if (lote?.pedagio === PedagioEnum.PEDAGIO_INCLUSO) {
          onChangeSwitchPedagio(true);
        } else {
          onChangeSwitchPedagio(false);
        }

        form.setFieldsValue({
          volume: lote.volume,
          cadencia: lote.cadencia,
          freteMotoristaPj: lote.freteMotoristaPj,
          freteEmpresaPj: lote.freteTotalPj || lote.freteEmpresaPj,
          freteMotoristaPf: lote.freteMotoristaPf,
          freteEmpresaPf: lote.freteTotalPf || lote.freteEmpresaPf,
          freteEmpresaShipper: lote.freteEmpresaShipper,
          dataInicio: moment(lote.dataInicio),
          dataFim: lote.dataFim && moment(lote.dataFim),
          direcionamento: lote.direcionamento,
          status: lote.idStatus,
          pedagio: lote.pedagio,
          ...(lote.nomeFantasiaProprietario && {
            [`direcionadoPara${lote.direcionamento}`]: `${
              lote.nomeFantasiaProprietario
            } - ${formatarCnpjCpfIMask(lote.cnpjCpfProprietario)}`,
          }),
          ...(lote.nomeGrupoFrotista && {
            [`direcionadoPara${lote.direcionamento}`]: `${lote.nomeGrupoFrotista}`,
          }),
          tipoDirecionamento: lote?.tipoDirecionamento,
          ...(lote?.razaoSocialTransportadora && {
            transportadora: `${lote.razaoSocialTransportadora}`,
          }),
        });
        if (lote.direcionamento) {
          setDirecionamentoSelected(
            DirecionamentoEnum.getTipo(lote.direcionamento)
          );
        }
        if (lote.tipoDirecionamento) {
          setTipoDirecionamentoSelected(
            TipoDirecionamentoEnum.getTipo(lote.tipoDirecionamento)
          );
        }
        if (lote.tipoDirecionamento === TipoDirecionamentoEnum.TRANSPORTADORA) {
          setIsTransportadora(true);
          handleTarifaClienteTmovTransportadora();
        } else {
          setIsTransportadora(false);
          handleTarifaClienteTmov();
        }

        setPreviousLoteData({
          volume: lote.volume,
          cadencia: lote.cadencia,
          frete: lote.freteEmpresaShipper,
        });

        setFreteInserido(lote.baseFreteShipper);
        setEditingLote(true);
        setFreteInserido(lote.baseFreteShipper);
      }

      if (
        lote.idLote &&
        (lote.idTransportadora === 1 ||
          lote.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE)
      ) {
        if (todosLotesInclusos) {
          const findLoteCarregando = todosLotesInclusos.find(
            todosLotes =>
              todosLotes.idStatus !== StatusLoteEnum.CARREGANDO &&
              todosLotes.idTransportadora !== 1 &&
              todosLotes.tipoDirecionamento !==
                TipoDirecionamentoEnum.MARKETPLACE
          );
          if (
            !findLoteCarregando &&
            lote.idStatus === StatusLoteEnum.CARREGANDO
          ) {
            setDisableStatus(true);
          }
        }
      }
    }
    onEditingLote();
  }, [lote, editingLote]);

  useEffect(() => {
    if (editingLote) return;

    const { freteMotoristaPj, freteMotoristaPf } = form.getFieldsValue();

    if (freteMotoristaPj || freteMotoristaPf) recalculaFretes();
  }, [valorPedagio, tarifaTmov]);

  useEffect(() => {
    form.validateFields(['dataInicio']);

    if (
      form.getFieldValue('dataFim') !== null &&
      form.getFieldValue('dataFim') !== undefined
    ) {
      form.validateFields(['dataFim']);
    }
  }, [form.getFieldValue('dataInicio'), form.getFieldValue('dataFim')]);

  const checkIfCadenciaIsValid = async value => {
    if (editingLote && lote?.cadenciaMovimentada) {
      await validateCadenciaMovimentado(
        value,
        lote?.cadenciaMovimentada,
        setIsCadenciaMovimentadaValid
      );
    }
  };

  const checkIfVolumeIsValid = async value => {
    if (editingLote && lote?.cadenciaMovimentada) {
      await validateVolumeMovimentado(
        value,
        lote?.cadenciaMovimentada,
        setIsVolumeMovimentadoValid
      );
    }
  };

  const checkIfDataInicioIsValid = async value => {
    const dataFim = form.getFieldValue('dataFim');
    setIsPeriodoValid(true);

    if (dataFim !== null && dataFim !== undefined) {
      if (moment(value).isAfter(dataFim)) {
        setIsPeriodoValid(false);
        return Promise.reject();
      }
    }
    return Promise.resolve();
  };

  const checkIfDataFimIsValid = async value => {
    const dataInicio = form.getFieldValue('dataInicio');
    setIsPeriodoValid(true);

    if (moment(dataInicio).isAfter(value)) {
      setIsPeriodoValid(false);
      return Promise.reject();
    }
    return Promise.resolve();
  };

  const onChangeValidateDate = () => {
    const { dataInicio, dataFim } = form.getFieldsValue(true);

    if (moment(dataInicio).isAfter(dataFim)) {
      setIsPeriodoValid(false);
    }
  };

  const onChangeValuesToForm = useDebouncedCallback(values => {
    if (
      editingLote &&
      typeof values === 'object' &&
      Object.keys(values).length > 0
    ) {
      const key = Object.keys(values);
      gTagSaida(
        `${getValueTagGA(key[0])} alterado(a)`,
        'Edição de Lote',
        `Campo ${getValueTagGA(key[0])} alterado(a) para ${values[key[0]]}`,
        eventId
      );
    }
  }, 2000);

  const tagGaFrete = checked => {
    gTagSaida(
      'Frete PF = PJ alterado',
      'Edição de Lote',
      `Frete PF = PJ alterado para ${checked ? 'Sim' : 'Não'}`,
      eventId
    );
  };

  const tagGaPedagio = checked => {
    gTagSaida(
      'Pedágio alterado',
      'Edição de Lote',
      `Pedágio alterado para ${checked ? 'Sim' : 'Não'}`,
      eventId
    );
  };

  const GetQtdMotoristasByData = async data => {
    try {
      const { data: numMotorista } = await apiShipper.get('/motoristas/size', {
        params: {
          idLotes: [lote.idLote],
          data,
        },
      });

      return numMotorista || 0;
    } catch (error) {
      notification.warn({
        message: 'Ops, não foi possível buscar os motorista dessa data',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    }
  };

  const handleDataAgendamento = async value => {
    let dataAgendamentoTratada = null;
    let qtdMotoristasByData = lote?.qtdMotoristasTransitoEmFila || 0;

    if (value) {
      dataAgendamentoTratada = pegarDataUtc(value);
      qtdMotoristasByData = await GetQtdMotoristasByData(
        dataAgendamentoTratada
      );
    }

    setQtdMotorista(qtdMotoristasByData);
    setDataAgendamento(dataAgendamentoTratada);
  };

  const mensagemAvisoFinalizar = motoristas => {
    const singular = 'motorista será removido';
    const plural = 'motoristas serão removidos';
    const isPlural = motoristas > 1;
    return `Ao finalizar o lote,
    ${motoristas} ${
      isPlural ? plural : singular
    } e as transportadoras notificadas.`;
  };

  const checkTransportadora = (_, value) => {
    if (value) {
      return Promise.resolve();
    }

    return Promise.reject(
      new Error('Por favor, selecione uma Transportadora!')
    );
  };

  const checkTransportadoras = (_, value) => {
    if (value.length > 0) {
      return Promise.resolve();
    }

    return Promise.reject(
      new Error('Por favor, selecione pelo menos uma Transportadora!')
    );
  };

  const handleSelectTransportadora = async id => {
    setIdsTransportadoras(id || []);
    if (id && (editingLote || !demanda.livreConcorrencia)) {
      const transportadora = empresasParceiras.find(
        empresa => empresa.id === id
      );
      form.setFieldsValue({
        razaoSocialTransportadora: transportadora.razaoSocial,
        idTransportadora: transportadora.id,
      });
    }
  };

  const handleSelectTransportadoras = async options => {
    setEmpresasOptions(options);
    const transportadoraIds = options
      .filter(option => option.checked)
      .map(option => option.id);
    setIdsTransportadoras(transportadoraIds || []);
  };

  return (
    <>
      <Modal
        title={title}
        width={900}
        onCancel={closeModal}
        visible={showModal}
        destroyOnClose={true}
        footer={[
          <CancelarButton key="cancel" onClick={closeModal}>
            Cancelar
          </CancelarButton>,
          <Button
            key="submit"
            onClick={handleGerenciarLote}
            disabled={disableModalSalvar}
          >
            {dataAgendamento ? 'Agendar' : 'Salvar'}
          </Button>,
        ]}
      >
        <RowAntd>
          <Form
            layout="vertical"
            onFinish={handleSubmitClient}
            onFieldsChange={validateFormDebounced}
            onValuesChange={onChangeValuesToForm}
            form={form}
          >
            <Row gutter={[12, 12]}>
              <Col>
                <Label>Direcionamento</Label>
              </Col>
            </Row>

            <Row>
              <Col span={11}>
                <Row>
                  <Col span={11}>
                    <Form.Item
                      name="tipoDirecionamento"
                      label="Tipo Direcionamento"
                    >
                      <Select
                        data-testid="tipo-direcionamento"
                        defaultValue={
                          tipoLote === 'MARKETPLACE'
                            ? tipoDirecionamentoOption[0].value
                            : tipoDirecionamentoOption[1].value
                        }
                        aria-label="tipoDirecionamento"
                        disabled={editingLote && lote?.idLote}
                        showAction={['click']}
                        onChange={value => handleTipoDirecionamento(value)}
                      >
                        {tipoDirecionamentoOption.map(option => (
                          <Select.Option
                            key={option.label}
                            value={option.value}
                          >
                            {`${option.label}`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  {!isTransportadora && (
                    <Col span={12} offset={1}>
                      <Form.Item
                        name="direcionamento"
                        label="Direcionamento para"
                      >
                        <Select
                          defaultValue={direcionamentoOption[0].value}
                          aria-label="direcionamento"
                          disabled={lote?.hasMotoristaLote || isTransportadora}
                          showAction={['click']}
                          onChange={(_value, option) =>
                            handleDirecionamento(option.index)
                          }
                        >
                          {direcionamentoOption.map((option, index) => (
                            <Select.Option
                              key={option.label}
                              index={index}
                              value={option.value}
                            >
                              {`${option.label}`}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                </Row>

                {direcionamentoSelected.value !== DirecionamentoEnum.PUBLICO &&
                  !isTransportadora && (
                    <Row style={{ maxWidth: 444 }}>
                      <Col span={24}>
                        <Form.Item
                          name={`direcionadoPara${direcionamentoSelected.value}`}
                          label="Buscar"
                          rules={[
                            {
                              required: true,
                              message: `Por favor, insira um ${direcionamentoSelected.label}`,
                            },
                          ]}
                        >
                          <Select
                            allowClear
                            showSearch
                            showArrow={false}
                            disabled={lote?.hasMotoristaLote}
                            placeholder={handleDirecionadoPara(
                              'Digite o CNPJ, razão social ou nome fantasia',
                              'Digite o nome do grupo',
                              direcionamentoSelected.value
                            )}
                            filterOption={false}
                            showAction={['click']}
                            onSelect={handleDirecionadoPara(
                              handleSelectFrotista,
                              handleSelectGrupoFrotista,
                              direcionamentoSelected.value
                            )}
                            notFoundContent={
                              loadingDirecionamento ? <LoadingOutlined /> : null
                            }
                            onSearch={handleDirecionadoPara(
                              onSearchFrotistas,
                              onSearchGrupoFrotistas,
                              direcionamentoSelected.value
                            )}
                            loading={loadingDirecionamento}
                          >
                            {// eslint-disable-next-line no-confusing-arrow
                            apiFrotistaOrGrupoFrotistas.map(dado =>
                              direcionamentoSelected.value ===
                              DirecionamentoEnum.FROTISTA
                                ? selectOptionFrotista(dado)
                                : selectOptionGrupoFrotista(dado)
                            )}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  )}

                {isTransportadora && (
                  <Row style={{ maxWidth: 444 }}>
                    <Col span={24}>
                      <Form.Item
                        name="transportadora"
                        label="Selecionar Transportadora(s)"
                        rules={[
                          {
                            validator:
                              editingLote || !demanda.livreConcorrencia
                                ? checkTransportadora
                                : checkTransportadoras,
                          },
                        ]}
                      >
                        {editingLote || !demanda.livreConcorrencia ? (
                          <Select
                            allowClear
                            disabled={
                              editingLote &&
                              (lote?.idLote ||
                                lote?.idTransportadora === Tmov.idEmpresa)
                            }
                            aria-label="transportadora"
                            data-testid="select-transportadora"
                            maxTagCount={2}
                            maxTagTextLength={20}
                            showSearch
                            showArrow={false}
                            placeholder="Selecione uma Transportadora"
                            filterOption={(input, { title: titleOption }) =>
                              filterOption(input, titleOption, 0)
                            }
                            showAction={['click']}
                            onChange={handleSelectTransportadora}
                          >
                            {empresasParceiras.map(dado => (
                              <Select.Option
                                key={dado.id}
                                value={dado.id}
                                title={`${
                                  dado.razaoSocial
                                } - ${formatarCnpjCpfIMask(dado.cnpj)}`}
                              >
                                {dado.razaoSocial}
                                &nbsp; - &nbsp;
                                {formatarCnpjCpfIMask(dado.cnpj)}
                              </Select.Option>
                            ))}
                          </Select>
                        ) : (
                          <MultiSelect
                            disabled={editingLote && lote?.idLote}
                            aria-label="transportadora"
                            label={`Selecionar Transportadoras ${
                              empresasSelecionadas.length > 0
                                ? `(${empresasSelecionadas.length} selecionadas)`
                                : ''
                            }`}
                            options={empresasOptions}
                            onChange={handleSelectTransportadoras}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col span={11}>
                    <Form.Item
                      name="dataInicio"
                      label="Data inicial"
                      rules={[
                        {
                          type: 'date',
                          required: true,
                          message: 'Por favor selecione uma data inicial!',
                        },
                        {
                          type: 'date',
                          required: false,
                          message:
                            'Por favor, insira uma data inicial menor que a data final!',
                          validator: (_, value) =>
                            checkIfDataInicioIsValid(value),
                        },
                      ]}
                      initialValue={moment()}
                    >
                      <DatePicker
                        aria-label="dataInicio"
                        className="total-width"
                        format="DD/MM/YYYY"
                        placeholder={moment().format('DD/MM/YYYY')}
                        disabledDate={d =>
                          !d || d.isBefore(moment().add(-1, 'days'))
                        }
                        disabled={lote?.hasMotoristaLote && editingLote}
                        onChange={onChangeValidateDate}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} offset={1}>
                    <Form.Item
                      name="dataFim"
                      label="Data final"
                      rules={[
                        {
                          type: 'date',
                          required: false,
                          message:
                            'Por favor, insira uma data final maior que a data inicial!',
                          validator: (_, value) => checkIfDataFimIsValid(value),
                        },
                      ]}
                    >
                      <DatePicker
                        className="total-width"
                        format="DD/MM/YYYY"
                        placeholder={moment()
                          .add(10, 'days')
                          .format('DD/MM/YYYY')}
                        disabledDate={d => !d || d.isBefore(moment())}
                        onChange={onChangeValidateDate}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {editingLote && lote?.idLote && (
                  <Row gutter={12}>
                    <Col span={24}>
                      <Form.Item
                        defaultValue={StatusLoteEnum.CARREGANDO}
                        name="status"
                      >
                        <Radio.Group onChange={handleStatus}>
                          {statusLoteOption.map(
                            (option, index) =>
                              option.active && (
                                <Radio
                                  key={option.label}
                                  index={index}
                                  value={option.value}
                                  disabled={disableStatus && option.value !== 1}
                                >
                                  {`${option.label}`}
                                </Radio>
                              )
                          )}
                        </Radio.Group>
                      </Form.Item>
                      {[
                        StatusLoteEnum.SUSPENSO,
                        StatusLoteEnum.FINALIZADO,
                      ].includes(statusSelected) &&
                        qtdMotorista > 0 && (
                          <AvisoFinalizar>
                            {mensagemAvisoFinalizar(qtdMotorista)}
                          </AvisoFinalizar>
                        )}
                    </Col>
                  </Row>
                )}

                <Row style={{ marginBottom: '15px' }}>
                  <Col>
                    <Label>Lote</Label>
                  </Col>
                </Row>

                <Row gutter={12}>
                  <Col span={11}>
                    <Form.Item
                      name="volume"
                      label="Volume total (ton)"
                      rules={[
                        {
                          required: true,
                          message:
                            'Por favor, insira o volume total em toneladas!',
                        },
                        {
                          validator: (_, value) => checkIfVolumeIsValid(value),
                        },
                      ]}
                    >
                      <NumberFormat
                        defaultValue={
                          demanda.livreConcorrencia ? demanda.volumeTotal : null
                        }
                        {...configTonelada}
                        disabled={demanda.livreConcorrencia}
                        className="total-width"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} offset={1}>
                    <Form.Item
                      name="cadencia"
                      label="Cadência diária (ton)"
                      rules={[
                        {
                          required: true,
                          message:
                            'Por favor, insira a cadência diária em toneladas!',
                        },
                        {
                          validator: (_, value) =>
                            validateCadencia(
                              value,
                              form.getFieldValue('volume')
                            ),
                        },
                        {
                          validator: (_, value) =>
                            checkIfCadenciaIsValid(value),
                        },
                      ]}
                    >
                      <NumberFormat
                        defaultValue={
                          demanda.livreConcorrencia
                            ? demanda.cadenciaDiariaTotal
                            : null
                        }
                        {...configTonelada}
                        disabled={demanda.livreConcorrencia}
                        className="total-width"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {!isTransportadora && (
                  <Row gutter={12} className="mt-10 mb-20">
                    <Col span={11}>
                      <SubTitle>
                        <SwitchAntd
                          checked={pedagioIncluso}
                          size="small"
                          onChange={value => {
                            onChangeSwitchPedagio(value);
                            tagGaPedagio();
                          }}
                          disabled={!valorPedagio || !tarifaTmovClienteLista}
                          aria-label="pedagioIncluso"
                        />
                        &nbsp;Incluir pedágio
                      </SubTitle>
                    </Col>

                    <Col span={12} offset={1}>
                      <SubTitle>
                        <SwitchAntd
                          checked={switchFretePf}
                          size="small"
                          onChange={value => {
                            onChangeSwitchFretePf(value);
                            tagGaFrete();
                          }}
                          disabled={false}
                          aria-label="switchFretePf"
                        />
                        &nbsp;Frete PF igual ao do PJ
                      </SubTitle>
                    </Col>
                  </Row>
                )}

                {!isTransportadora && (
                  <Row>
                    <Col span={11}>
                      <Form.Item
                        className="mb-5"
                        name="freteMotoristaPj"
                        label="Frete Motorista (PJ)"
                        rules={[
                          {
                            required: true,
                            message:
                              'Por favor, insira o valor do frete motorista (pj)',
                          },
                        ]}
                      >
                        <NumberFormat
                          {...novaMoneyConfig}
                          disabled={false}
                          className="total-width"
                          onChange={event =>
                            calculaFretesDebounced(
                              event.target.value,
                              'motorista',
                              'PJ'
                            )
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={12} offset={1}>
                      <Form.Item
                        name="freteEmpresaPj"
                        label="Frete Empresa (PJ)"
                        rules={[
                          {
                            required: true,
                            message:
                              'Por favor, insira o valor do frete empresa (pj)',
                          },
                        ]}
                      >
                        <NumberFormat
                          {...novaMoneyConfig}
                          disabled={!isTransportadora}
                          className="total-width"
                          onChange={event =>
                            calculaFretesDebounced(
                              event.target.value,
                              'empresa',
                              'PJ'
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                {!switchFretePf && !isTransportadora && (
                  <Row>
                    <Col span={11}>
                      <Form.Item
                        className="mb-5"
                        name="freteMotoristaPf"
                        label="Frete Motorista (PF)"
                        style={{ marginBottom: 0 }}
                      >
                        <NumberFormat
                          {...novaMoneyConfig}
                          disabled={switchFretePf}
                          className="total-width"
                          onChange={event =>
                            calculaFretesDebounced(
                              event.target.value,
                              'motorista',
                              'PF'
                            )
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={12} offset={1}>
                      <Form.Item
                        name="freteEmpresaPf"
                        label="Frete Empresa (PF)"
                        style={{ marginBottom: 0 }}
                      >
                        <NumberFormat
                          {...novaMoneyConfig}
                          // disabled={switchFretePf}
                          disabled={!isTransportadora}
                          className="total-width"
                          onChange={event =>
                            calculaFretesDebounced(
                              event.target.value,
                              'empresa',
                              'PF'
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                {isTransportadora && (
                  <Col span="11">
                    <Form.Item
                      name="freteEmpresaShipper"
                      label="Frete Empresa"
                      rules={[
                        {
                          required: true,
                          message:
                            'Por favor, insira o valor do frete empresa shipper',
                        },
                      ]}
                    >
                      <NumberFormat
                        {...novaMoneyConfig}
                        disabled={!isTransportadora}
                        className="total-width"
                        onChange={event =>
                          calculaFretesDebounced(
                            event.target.value,
                            'empresa',
                            'PJ'
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                )}
              </Col>

              <Col span={12} offset={1}>
                {!isTransportadora && (
                  <>
                    <ParametroValores
                      enderecos={dadosEndereco}
                      descricaoProduto={descricaoProduto}
                      icms={icms * 100}
                      tarifaTmov={tarifaTmov}
                      isPercentualTmov={isTarifaPercentual}
                      pedagio={valorPedagio}
                    />

                    <TarifaClienteTmov
                      tarifas={
                        tarifaTmovClienteLista
                          ? tarifaTmovClienteLista.tarifas
                          : []
                      }
                      tipoTarifa={
                        tarifaTmovClienteLista
                          ? tarifaTmovClienteLista.tipoTarifa
                          : 'REAIS'
                      }
                    />
                  </>
                )}

                {editingLote && !loadingAgendamento && lote?.idLote && (
                  <>
                    <Row className="mt-15 mb-15">
                      <Col>
                        <Label>Agendar alteração dos valores</Label>
                      </Col>
                    </Row>
                    <Row>
                      <p style={{ marginBottom: '8px' }}>Data de alteração</p>
                    </Row>
                    <Row>
                      <Col span={11}>
                        <DatePicker
                          className="total-width"
                          disabled={!!dadosAgendamento}
                          disabledDate={d => !d || d.isBefore(moment())}
                          onChange={handleDataAgendamento}
                          format="DD/MM/YYYY"
                        />
                      </Col>
                      {dadosAgendamento && (
                        <Col span={11} offset={2}>
                          <Popconfirm
                            title="Tem certeza que deseja cancelar este agendamento? Esta ação é irrevesível"
                            onConfirm={handleCancelarAgendamento}
                          >
                            <CancelarAgendamentoButton
                              type="primary"
                              data-testid="cancelar-agendamento"
                            >
                              Cancelar Agendamento
                            </CancelarAgendamentoButton>
                          </Popconfirm>
                        </Col>
                      )}
                    </Row>

                    {dadosAgendamento && !loadingAgendamento && (
                      <AgendamentoInfo
                        dataAgendada={dadosAgendamento.DataAlteracao}
                        freteEmpresaShipperAgendada={
                          dadosAgendamento.FreteEmpresaShipper
                        }
                        cadenciaAgendada={dadosAgendamento.Cadencia}
                        volumeAgendado={dadosAgendamento.Volume}
                        freteMotoristaPfAgendado={
                          dadosAgendamento.FreteMotoristaPf
                        }
                        freteMotoristaPjAgendado={
                          dadosAgendamento.FreteMotoristaPj
                        }
                        freteEmpresaPfAgendado={dadosAgendamento.FreteEmpresaPf}
                        freteEmpresaPjAgendado={dadosAgendamento.FreteEmpresaPj}
                        tipoDirecionamento={lote.tipoDirecionamento}
                        statusAgendado={dadosAgendamento.StatusLote}
                      />
                    )}
                  </>
                )}

                {loadingAgendamento && (
                  <AgendamentoLoadingContainer>
                    <LoadingOutlined style={{ fontSize: '30px' }} />
                  </AgendamentoLoadingContainer>
                )}
              </Col>
            </Row>
          </Form>
        </RowAntd>
      </Modal>
    </>
  );
}

ModalCriarLote.propTypes = {
  demanda: PropTypes.objectOf(PropTypes.any).isRequired,
  showModal: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onSaveLote: PropTypes.func.isRequired,
  setFreteInserido: PropTypes.func.isRequired,
  freteInserido: PropTypes.string,
  dadosPagador: PropTypes.shape({
    cnpj: PropTypes.string,
    id: PropTypes.number,
    id_cliente_raiz: PropTypes.number,
    razao_social: PropTypes.string,
  }).isRequired,
  formDemanda: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ).isRequired,
  endereco: PropTypes.objectOf(PropTypes.any).isRequired,
  eventId: PropTypes.string,
  lote: PropTypes.objectOf(PropTypes.any),
  icms: PropTypes.number.isRequired,
  valorPedagio: PropTypes.number.isRequired,
  tarifaTmovClienteLista: PropTypes.shape({
    tarifas: PropTypes.arrayOf(PropTypes.any),
    tipoTarifa: PropTypes.string,
  }).isRequired,
  empresasParceiras: PropTypes.arrayOf(PropTypes.any).isRequired,
  todosLotesInclusos: PropTypes.arrayOf(PropTypes.any),
  tipoLote: PropTypes.string.isRequired,
};

ModalCriarLote.defaultProps = {
  freteInserido: 'motorista',
  eventId: '',
  lote: null,
  todosLotesInclusos: null,
};
